/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, ElementRef, HostListener, OnDestroy, OnInit } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

@Directive({
  selector: '[wellKeepInScreen]',
  standalone: true
})
export class KeepInScreenDirective implements OnInit, OnDestroy {

  screenWidth: ReplaySubject<number> = new ReplaySubject<number>()
  destroy: Subject<boolean> = new Subject<boolean>()

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth.next(window.innerWidth);

  }

  constructor(private el: ElementRef) {

  }

  ngOnInit(): void {
    this.screenWidth.next(window.innerWidth)

    this.screenWidth.pipe(
      takeUntil(this.destroy),
      debounceTime(200),
    )
      .subscribe( screenWidth => {
        const rect = this.el.nativeElement.getBoundingClientRect()
        if(screenWidth < rect.right) {

          this.el.nativeElement.style.right = '0px';
        }
      })
  }

  ngOnDestroy(): void {
    this.destroy.next(true)
  }
}

